// extracted by mini-css-extract-plugin
export default {"root":"Stories-root-35a62e9ebca01004a515f7718e3719a4"};